import type { ModuleWithProgress } from '@/lib/api/lms';

export interface ResumeTarget { moduleId: string; topicId: string; }

/** First in_progress topic; else first not_started; else null (course complete). */
export function pickResumeTarget(modules: ModuleWithProgress[]): ResumeTarget | null {
  for (const pass of ['in_progress', 'not_started'] as const) {
    for (const m of modules) {
      const t = [...m.topics].sort((a, b) => a.sort_order - b.sort_order)
        .find((t) => t.status === pass);
      if (t) return { moduleId: m.id, topicId: t.id };
    }
  }
  return null;
}

/** Module to auto-expand: the resume module, else first incomplete, else first. */
export function findCurrentModuleId(modules: ModuleWithProgress[]): string | null {
  const target = pickResumeTarget(modules);
  if (target) return target.moduleId;
  const incomplete = modules.find((m) => m.completed_count < m.topic_count);
  return incomplete?.id ?? modules[0]?.id ?? null;
}
